import { combineReducers } from 'redux'
import profile from './profile.reducer'
import patient from './patient.reducer'
import surgeon from './surgeon.reducer'
import feedback from './feedback.reducer'
import user from './user.reducer'
import regimen from './regimen.reducer'
import schedule from './schedule.reducer'
import exercise from './exercise.reducer'
import customer from './customer.reducer'
import company from './company.reducer'
import message from './message.reducer'
import event from './event.reducer'
import device from './device.reducer'
import actioncase from './actioncase.reducer'
import notification from './notification.reducer'
import patientnotes from './patientnotes.reducer'
import settings from './settings.reducer'

export default combineReducers({
  profile,
  patient,
  surgeon,
  feedback,
  user,
  regimen,
  schedule,
  exercise,
  customer,
  company,
  message,
  event,
  device,
  actioncase,
  notification,
  patientnotes,
  settings,
})
